// extracted by mini-css-extract-plugin
export default {"circle_divisions_legend":"styles_circle_divisions_legend__Y6Cth","circle_divisions_legend_item":"styles_circle_divisions_legend_item__dmMax"};